export interface IntervalSchedulerOptions {
  interval: number;
  onTick: () => void;
  onScheduled?: () => void;
  onStop?: () => void;
  config?: {
    abortOnReSchedule?: boolean;
  };
}

export class IntervalScheduler {
  private interval: number | undefined;

  constructor(private options: IntervalSchedulerOptions) {}

  private scheduleTick(): void {
    this.interval = window.setInterval(() => {
      this.options.onTick();
    }, this.options.interval);
  }

  public start(): void {
    if (this.options.config?.abortOnReSchedule && this.isRunning) this.stop();
    this.options.onScheduled?.();
    this.scheduleTick();
  }

  public stop(): void {
    if (!this.isRunning) return;
    this.options.onStop?.();
    clearInterval(this.interval);
    this.interval = undefined;
  }

  public get isRunning(): boolean {
    return this.interval !== undefined;
  }
}
